import { Component, OnInit } from '@angular/core';
import _ from 'lodash';
import { DIA_SEMANA, MES } from 'src/app/global/interfaces/agenda-literales';
import { AgendaServiceVM } from 'src/app/view-model/services/agenda-vm.service';

@Component({
  selector: 'app-fecha-entrega',
  templateUrl: './fecha-entrega.component.html',
  styleUrls: ['./fecha-entrega.component.scss']
})
export class FechaEntregasComponent implements OnInit {

  fechaEntrega;
  showAgenda = false;


  constructor(private agendaService: AgendaServiceVM) {}

  async ngOnInit() {
    try {
      const agenda = await this.agendaService.getAgendaSinFormato();
      if ( agenda.indicador ) {
        if ( agenda.indicador === 'COMERCIO_NO_AGENDABLE') {
          this.showAgenda = false;
        } else {
          this.fechaEntrega = this.formatFecha(_.get(agenda, 'data.value1'));
          this.showAgenda = true;
        }
      } else {
        this.fechaEntrega = this.formatFecha(_.get(agenda, 'data.value1'));
        this.showAgenda = true;
      }
    } catch (e) {
      this.showAgenda = false;
      console.error('Error: ', e);
    }

  }

  private formatFecha(fecha: any): any {
    const miFecha: Date = new Date(fecha + 'T00:00:00');
    const dia = miFecha.getDate();
    const mes = miFecha.getMonth();
    const anio = miFecha.getFullYear();
    const diaSemana = miFecha.getDay();
    return {
        fecha,
        dia,
        nombreDia: DIA_SEMANA[diaSemana],
        nombreMes: MES[mes],
        anio
    };
  }


}
